import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Form, Formik, FormikHelpers } from 'formik';
import { ProfileService } from 'services/profile/profile';
import { initialValues, validationSchema } from './form';
import { ICompanyInfo } from 'core/interface/matchProfile';
import { IIndustry } from 'core/interface/companies';
import useLocales from 'hooks/useLocales';
import Autocomplete from 'components/shared/Autocomplete/Index';
import FormField from 'components/FormField/Index';
import { InputType } from 'core/enum/inputType';
import Button from 'components/Button/Index';
import { RootState } from '../../../../redux/store';
import { getIndustryDisplayName } from 'utils/industry';
import Activation from '../Index';

import './Index.scss';

interface CompanyInfoProps {
  onSubmit: any;
  onBack: any;
  setCompanyData: any;
  currentStep: number;
  totalSteps: number;
}

const CompanyInfo = ({
  onSubmit,
  onBack,
  setCompanyData,
  currentStep,
  totalSteps
}: CompanyInfoProps): JSX.Element => {
  const { t } = useLocales();
  const { industry: industries } = useSelector(
    (state: RootState) => state.industries
  );
  const [selectedIndustry, setSelectedIndustry] = useState<IIndustry | null>(
    null
  );

  const getIndustries = async (query?: string): Promise<void> => {
    ProfileService.getIndustries(query);
  };

  const handleSubmit = async (
    values: ICompanyInfo,
    _actions: FormikHelpers<ICompanyInfo>
  ) => {
    setCompanyData((prev: any) => ({
      ...prev,
      ...values,
      industry: selectedIndustry
    }));
    onSubmit();
  };

  return (
    <Activation
      title={t('Nice to meet you')}
      currentStep={currentStep}
      totalSteps={totalSteps}
    >
      <>
        <h4 className="company-info">
          {t('Please tell us a little bit more about your company')}
        </h4>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={(values, actions) => handleSubmit(values, actions)}
          validationSchema={validationSchema(t)}
        >
          {({ setFieldValue, values }) => (
            <Form className="form">
              <div className="field">
                <span className="label">{t('Industry')}</span>
                <Autocomplete
                  fieldName="industry"
                  value={
                    selectedIndustry?.name ||
                    getIndustryDisplayName(values.industry)
                  }
                  options={
                    industries?.map((e) => ({
                      id: e?.id,
                      title: e?.name
                    })) || []
                  }
                  show_location={false}
                  show_arrow={true}
                  placeholder={t('Industry')}
                  onChange={(e) => {
                    const found = industries?.find(
                      (industry) => industry.name === e
                    );
                    if (found) {
                      const industry: IIndustry = {
                        id: found.id,
                        name: found.name
                      };
                      setSelectedIndustry(industry);
                      setFieldValue('industry', industry);
                    }
                  }}
                  onInputChange={(e) => {
                    getIndustries(e);
                  }}
                  values={industries}
                />
              </div>
              <div className="field">
                <span className="label">{t('Company name')}</span>
                <FormField
                  inputClassName="input"
                  fieldName="name"
                  placeholder={t('Company name')}
                  type={InputType.text}
                />
              </div>
              <div className="av__content__buttons ">
                <Button
                  onClick={onBack}
                  t={t}
                  title="Back"
                  className="av__content__buttons-back"
                />
                <Button
                  type="submit"
                  t={t}
                  title="Next"
                  className="av__content__buttons-next"
                />
              </div>
            </Form>
          )}
        </Formik>
      </>
    </Activation>
  );
};

export default CompanyInfo;
